// reactstrap components
import { Container } from "reactstrap";
import { useQuery } from "@apollo/client";
import CurrentUserData from "../../queries/CurrentUserData.js";
import Spinner from "../../components/Spinner.jsx";
// core components
import Header from "../../components/Headers/Header.js";
import Dashboard from "../../components/Dashboard.js";

const UserIndex = (props) => {
  console.log("UserIndex props:", props);
  const { loading, error, data } = useQuery(CurrentUserData);

  if (loading) return <Spinner />;
  if (error) {
    console.log("error:");
    console.log(error);
    return <p>Something Went Wrong...</p>;
  }

  return (
    <>
      <Header
        title={`Welcome ${data.currentUserData.user_name}`}
        description={`Thank you for your participation in this important effort. 
        You are reviewing Course II ${data.currentUserData.survey_language.charAt(0).toUpperCase()}${data.currentUserData.survey_language.slice(1)}. Please read these instructions before you continue.`}
      />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Dashboard />
      </Container>
    </>
  );
};

export default UserIndex;
